import React, { Component } from 'react'
import Drawer from 'react-drag-drawer';
import './Popupstyle.css';
import { BoxLoading } from 'react-loadingg';
import ThemeManager from './ThemeManager';
import i18n from "i18next";

export class PaymentOption extends Component {

    constructor(props) {
        super(props);

        this.state = { canPay: true, openLoader: false };
    }


    toggleLoader = () => {
        this.setState({ openLoader: false })
    }


    payNow = (e) => {
        if (this.state.canPay) {
            this.setState({ canPay: false });

            this.setState({ openLoader: true })

            this.props.pay();

        }
    }

    render() {

        let themeManager = ThemeManager.getInstance();
        const _selectionColor = themeManager.getSelectionColor();
        const _buttonTextColor = themeManager.getButtonTextColor();


        return (
            <div>
                <div style={{ marginTop: '10px', color: 'rgb(198,210,25)', fontSize: '11px', fontWeight: 'bold' }}>
                    🔒 {i18n.t('secure.payment')}
                </div>

                <div><div style={{ marginTop: '5px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{
                        cursor: 'pointer', fontWeight: 'bold', height: '40px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px',
                        textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor, opacity: this.state.canPay ? '1.0' : '0.5'
                    }}
                        onClick={this.payNow}
                    >{i18n.t('pay.now')}</p>
                </div>
                </div>

                <Drawer
                    open={this.state.openLoader}
                    onRequestClose={this.toggleLoader}
                    modalElementClass="modal">
                    <div>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ marginTop: '30px', fontSize: '14px', color: 'rgb(60,60,60)' }}>{i18n.t('payment.ongoing')}</div>
                        </div>
                        <div style={{ marginTop: '60px', height: '50px !important' }}>
                            <BoxLoading color={_selectionColor} />
                        </div>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ marginTop: '30px', fontSize: '14px', color: 'rgb(60,60,60)' }}>{i18n.t('wait')}</div>
                        </div>

                    </div>
                </Drawer>

            </div>
        )
    }
}

export default PaymentOption
